import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .overlay h3.rules-header {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 40px 20px 0px 45px;
  }

  .overlay ul {
    margin: 0 20px 0 65px;
  }

  .overlay ul li {
    list-style-type: disc;
    margin: 3px 0;
    font-size: 1.3rem;
  }
  .overlay ul li p {
    margin: 0 0 0px 0;
    line-height: 130%;
    font-size: 0.8rem;
  }
`

const developerCSS = css``

export const HiLoRulesCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
export const Close = styled(IconLib).attrs({ collection: 'general', name: 'closeOutline', dimension: '25px' })`
  position: absolute;
  left: 10px;
  top: 10px;
  background: rgba(255, 255, 255, 1);
  :hover {
    cursor: pointer;
  }
`
